import React from 'react';
import './Stars.scss';

function Stars() {
    return (
        <div>
            {/* Empty divs for each layer of stars */}
            <div id="stars"></div>
            <div id="stars2"></div>
            <div id="stars3"></div>
        </div>
    );
}

export default Stars;